import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ScreenPagePart from "../../components/login/screenpage";
import RecoverPasswordForm from "../../components/login/recover";
import PreloaderPage from "../../pages/preloader";
import { backend } from "../../services/backend";
import { toast } from "sonner";
import { generateRandomString, isValidEmail } from "../../utils";

const EmailConfirmPage = () => {
  const [pending, Pending] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [success, setSuccess] = useState(false);
  const [emailToRequest, setEmailToRequest] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [newEmail, setNewEmail] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      setSuccess(false);
      setLoaded(true);
      return;
    }
    backend
      .sendEmailToConfirm(token)
      .then((res) => {
        toast("Адрес успешно подтвержден");
        setSuccess(true);
        setTimeout(() => {
          document.location.href = "/";
        }, 3000);
      })
      .catch((e) => {
        toast("Не удалось подтвердить адрес");
        setSuccess(false);
      })
      .finally(() => {
        setLoaded(true);
      });
  }, [newEmail]);

  const validateEmail = () => {
    const val = emailToRequest;
    if (!isValidEmail(val)) {
      setEmailErrorMessage("Неверный адрес электонной почты");
      return;
    }
    Pending(true);
    backend
      .requestEmailConfirmByEmail(val)
      .then((res) => {
        if (res.error) {
          toast("Ошибка отправки запроса");
        }
        toast(
          "Запрос успешно отправлен. Перейдите по ссылке, отправленной Вам на емейл"
        );
      })
      .catch(() => {
        toast("Ошибка отправки запроса");
      })
      .finally(() => {
        Pending(false);
      });
  };

  if (!loaded) {
    return <PreloaderPage />;
  }

  return (
    <ScreenPagePart>
      <div className="inner centerItem">
        {!success ? (
          <div className="errorContentInner">
            <h3>Подтвердите адрес электронной почты</h3>
            <input
              style={{
                width: 300
              }}
              type="email"
              name="email"
              value={emailToRequest}
              onChange={(event: any) => {
                const val = event.target.value;
                const valid = isValidEmail(val);
                console.log("Valid:", valid)
                setEmailErrorMessage(valid ? "" : "Неверный адрес электронной почты");
                setEmailToRequest(event.target.value?.toLowerCase());
              }}
            />
            {emailErrorMessage && (
              <div className="errorText">{emailErrorMessage}</div>
            )}
            <div
              className={`btn loginActionButton${pending ? " disabled" : ""}`}
              onClick={validateEmail}
            >
              Отправить подтверждение
            </div>
          </div>
        ) : (
          <div className="errorContentInner">
            <h1>Емейл успешно подтвержден</h1>
            <h3>Теперь Вы можете войти</h3>
            <p>
              <a href="/login">Войти</a>
            </p>
          </div>
        )}
      </div>
    </ScreenPagePart>
  );
};

export default EmailConfirmPage;
